// @flow
import { commitMutation, graphql } from 'react-relay';
import { Environment } from 'relay-runtime';

const mutation = graphql`
  mutation ShopWithCeoAddMutation($input: ShopWithCeoAddInput!) {
    shopWithCeoAdd(input: $input) {
      clientMutationId
      user {
        id
        email
        shoppingWithCeoUser {
          publicId
          userId
          firstName
          lastName
          profile {
            image
            city
            state
            zip
          }
        }
      }
      cart {
        id
        eventId
        billingAddress {
          guestShoppingWithCEO
        }
      }
      cartV2 {
        id
        eventId
      }
    }
  }
`;

interface ShopWithCeoAddMutationCommitParam {
  environment: Environment;
  ceoCustomUrl?: string;
  ceoId?: string; // Use this to input a CE's public ID
  eventId?: string;
  trinityDealerId?: string;
  ceAccountId?: string; // Use this to input a CE's account ID
  onCompleted: any;
  onError: any;
}

// See ShopWithCeoAddMutationCommitParam for comments
function commit({
  environment,
  ceoCustomUrl,
  ceoId,
  eventId,
  trinityDealerId,
  ceAccountId,
  onCompleted,
  onError,
}: ShopWithCeoAddMutationCommitParam) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        ceoCustomUrl: ceoCustomUrl || null,
        ceoId: ceoId || null,
        eventId: eventId || null,
        trinityDealerId: trinityDealerId || null,
        ceAccountId: ceAccountId || null,
      },
    },
    onCompleted,
    onError,
  });
}

export default { commit };
